import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { Route, Routes } from "react-router-dom";
import { Modal, Button, FormGroup, Input, Label } from "../components/Modal";
import * as AccountStore from "../account/AccountStore";
import { ManageExternalClient } from "../clients/ManageExternalClient";
import ClientPermissions from "../clients/ClientPermissions";
import ClientSecrets from "../clients/ClientSecrets";
import ClientsTable from "../clients/ClientsTable";
import { DeleteClient, GetClient } from "../clients/ClientStore";
import CreateClient from "../clients/Create";
import { EditClient, Client } from "../clients/Edit";
import { alert } from "../general/alertStore.js";
import { GetContext, UnsubscribeContext } from "../general/ApplicationContext";
import * as PermissionStore from "../identityPermissions/IdentityPermissionStore";
import CreateIdentityProvider, { IdentityProviderTypes } from "../identityProviders/Create";
import { DeleteIdentityProvider, UpdateIdentityProvider } from "../identityProviders/IdentityProviderStore";
import Integrations from "../integrations/Integrations";
import OrganizationContextSwitcher from "../organizations/ContextSwitcher";
import OrganizationBranding from "./OrganizationBranding";
import OrganizationCommunication from "./OrganizationCommunication";
import OrganizationManagedServices from "./OrganizationManagedServices";
import OrganizationMembership from "./OrganizationMembership";
import OrganizationRegistration from "./OrganizationRegistration";
import OrganizationRegistrationLinks from "./OrganizationRegistrationLinks";
import { getOrganization, updateOrganization } from "./OrganizationStore";
import OrganizationUserPermissions from "./OrganizationUserPermissions";
import OrganizationRoles from "./OrganizationRoles";

const { Component } = React;

interface OrganizationIndexState {
    selectedOrganization: any;
    showCreateClientModal: boolean;
    showEditClientModal: boolean;
    showIdentityProviderModal: boolean;
    currentClient?: Client;
    policies: any;
    currentUser: any;
}

class Organization {
    id: string;
    name: string;
    defaultDomain: string;
    scadsysOnlineSchoolID: string;
    constructor() {
        this.id = "";
        this.name = "";
        this.defaultDomain = "";
        this.scadsysOnlineSchoolID = "";
    }
}

let contextSubscriptionId = "";

export const Tabs = [
    { permission: "manageOrganizations", route: "/organizations/information", icon: ["fad", "square-info"], name: "Information", description: "Update organization details" },
    { permission: "manageClients", route: "/organizations/clients", icon: ["fad", "sitemap"], name: "Clients", description: "Manage external applications' authentication" },
    {
        permission: "manageOrganizationRegistration",
        route: "/organizations/registration",
        icon: ["fad", "user-plus"],
        name: "Registration",
        description: "Registration links and third-party providers",
    },
    {
        permission: "executeIntegrations",
        route: "/organizations/integrations",
        icon: ["fad", "diagram-project"],
        name: "Integrations",
        description: "Manage and run third-party integrations",
    },
    { permission: "manageOrganizationMembership", route: "/organizations/membership", icon: ["fad", "users"], name: "Membership", description: "View existing user membership" },
    { permission: "permissions.read", route: "/organizations/permissions", icon: ["fad", "users-gear"], name: "Permissions", description: "User and resource access management" },
    { permission: "manageUserPermissions", route: "/organizations/roles", icon: ["fad", "user-shield"], name: "Roles", description: "Create and manage roles with permissions" },
    {
        permission: "listManagedServices",
        route: "/organizations/managedServices",
        icon: ["fad", "gears"],
        name: "Managed Services",
        description: "Create and connect managed service applications",
    },
    { permission: "manageOrganizationCommunication", route: "/organizations/communication", icon: ["fad", "phone"], name: "Communication", description: "Send emails" },
    { permission: "manageOrganizationBranding", route: "/organizations/branding", icon: ["fad", "palette"], name: "Branding", description: "Customize branding and colors" },
];

function GetTab(location) {
    let tab = Tabs.filter((t) => t.route == location)[0];

    return tab;
}

export default class OrganizationIndex extends Component<{ navigate: any; location: any }, OrganizationIndexState> {
    constructor(props) {
        super(props);
        this.state = {
            selectedOrganization: undefined,
            showCreateClientModal: false,
            showEditClientModal: false,
            showIdentityProviderModal: false,
            policies: undefined,
            currentUser: undefined,
        };
    }

    hasPermission(permission) {
        if (this.state.currentUser && this.state.policies) {
            if (this.state.currentUser.claims.filter((c) => c.type == "http://schemas.microsoft.com/ws/2008/06/identity/claims/role" && c.value == "Admin").length > 0) {
                return true;
            } else {
                if (permission === "permissions.read") return this.state.policies.some(policy => /^(permissions\.read|permissions\.manage)(:|$)/.test(policy.permission));
                return this.state.policies.filter((policy) => policy.permission == permission).length > 0;
            }
        }
        return false;
    }

    componentDidMount() {
        contextSubscriptionId = GetContext((context) => {
            AccountStore.GetCurrentLoggedInUser().then((user) => {
                this.setState({ currentUser: user });
            });
            PermissionStore.GetMyPermissions().then((response) => {
                this.setState({ policies: response.data });
            });
            this.handleChange(context.currentOrganization.id);
        });
        // this.selectTab(Tabs[0], 0)();
    }

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    handleChange = (organization) => {
        if (organization) {
            getOrganization(organization)
                .then((result) => {
                    this.setState({ selectedOrganization: result });
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        let org = new Organization();
                        org.name = "Access Denied";
                        this.setState({ selectedOrganization: org });
                    }
                });
        } else {
            this.setState({
                selectedOrganization: undefined,
            });
        }
    };

    handleNameChange = (e) => {
        var name = e.target.value;

        this.setState((prevState) => {
            prevState.selectedOrganization.name = name;

            return prevState;
        });
    };

    handleScadsysWebRefChange = (e) => {
        var ref = e.target.value;

        this.setState((prevState) => {
            prevState.selectedOrganization.scadsysOnlineSchoolID = ref;

            return prevState;
        });
    };

    handleDomainChange = (e) => {
        var name = e.target.value;

        this.setState((prevState) => {
            prevState.selectedOrganization.defaultDomain = name;

            return prevState;
        });
    };

    handleLogoChange = (e) => {
        var logo = e.target.value;

        this.setState((prevState) => {
            prevState.selectedOrganization.logoUri = logo;

            return prevState;
        });
    };

    handleShortCodeChange = (e) => {
        var shortCode = e.target.value;

        this.setState((prevState) => {
            prevState.selectedOrganization.shortCode = shortCode;

            return prevState;
        });
    };

    handleAllowEmailLoginChange = (e) => {
        var value = e.target.checked;

        this.setState((prevState) => {
            prevState.selectedOrganization.allowEmailLogin = value;

            return prevState;
        });
    };

    toggleCreateClientModal = () => {
        if (this.state.showCreateClientModal) {
            this.handleChange(this.state.selectedOrganization.id);
        }
        this.setState((prevState) => ({
            showCreateClientModal: !prevState.showCreateClientModal,
        }));
    };

    toggleIdentityProviderModal = () => {
        if (this.state.showIdentityProviderModal) {
            this.handleChange(this.state.selectedOrganization.id);
        }
        this.setState((prevState) => ({
            showIdentityProviderModal: !prevState.showIdentityProviderModal,
        }));
    };

    updateOrganization = () => {
        return updateOrganization(this.state.selectedOrganization.id, this.state.selectedOrganization).then(
            () => {},
            (error) => {
                alert(error.message);
            }
        );
    };

    deleteIdentityProvider = (id) => {
        DeleteIdentityProvider(id).then(() => {
            this.handleChange(this.state.selectedOrganization.id);
        });
    };

    updateIdentityProvider = (idp) => {
        UpdateIdentityProvider(idp).then(() => {
            getOrganization(this.state.selectedOrganization.id).then((result) => {
                this.setState({ selectedOrganization: result });
            });
        });
    };

    Information = () => {
        return (
            this.hasPermission("manageOrganizations") && (
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    {/* Header Section */}
                    <div className="flex items-center gap-3 pb-4 border-b border-gray-200">
                        <FontAwesomeIcon icon={["fad", "info-square"]} className="text-3xl text-purple-500" />
                        <div>
                            <h2 className="text-2xl font-semibold text-gray-800">Information</h2>
                            <p className="text-sm text-gray-600">View and manage organization information</p>
                        </div>
                    </div>

                    <div className="space-y-4 max-w-2xl">
                        <FormGroup>
                            <Label>ID</Label>
                            <div className="px-3 py-2 bg-gray-50 rounded-md text-sm text-gray-700 font-mono">{this.state.selectedOrganization.id}</div>
                        </FormGroup>

                        <FormGroup>
                            <Label>Name</Label>
                            <Input type="text" onChange={this.handleNameChange} value={this.state.selectedOrganization.name || ""} placeholder="Enter organization name" />
                        </FormGroup>

                        <FormGroup>
                            <Label>Scadsys Online School ID</Label>
                            <Input type="text" onChange={this.handleScadsysWebRefChange} value={this.state.selectedOrganization.scadsysOnlineSchoolID || ""} placeholder="Enter school ID" />
                        </FormGroup>

                        <FormGroup>
                            <Label>Default Domain</Label>
                            <Input type="text" onChange={this.handleDomainChange} value={this.state.selectedOrganization.defaultDomain || ""} placeholder="example.com" />
                        </FormGroup>

                        <FormGroup>
                            <Label>Logo URI</Label>
                            <Input type="text" onChange={this.handleLogoChange} value={this.state.selectedOrganization.logoUri || ""} placeholder="https://example.com/logo.png" />
                        </FormGroup>

                        <FormGroup>
                            <Label>Short Code</Label>
                            <Input type="text" onChange={this.handleShortCodeChange} value={this.state.selectedOrganization.shortCode || ""} placeholder="Enter short code" />
                        </FormGroup>

                        <FormGroup>
                            <Label className="flex items-center space-x-2">
                                <Input type="checkbox" id="allowEmailLoginLinks" checked={this.state.selectedOrganization.allowEmailLogin || false} onChange={this.handleAllowEmailLoginChange} />
                                <span>Allow Email Login Links</span>
                            </Label>
                        </FormGroup>

                        <div className="pt-4">
                            <Button variant="primary" onClick={this.updateOrganization}>
                                <FontAwesomeIcon icon={["fad", "save"]} className="mr-2" />
                                Update Organization
                            </Button>
                        </div>
                    </div>
                </div>
            )
        );
    };

    Registration = () => {
        return (
            <OrganizationRegistration
                organization={this.state.selectedOrganization}
                hasPermission={this.hasPermission.bind(this)}
                onDeleteIdentityProvider={this.deleteIdentityProvider}
                onUpdateIdentityProvider={this.updateIdentityProvider}
                onToggleIdentityProviderModal={this.toggleIdentityProviderModal}
            />
        );
    };

    Integrations = () => {
        return this.hasPermission("executeIntegrations") && <Integrations organization={this.state.selectedOrganization.id}></Integrations>;
    };
    Membership = () => {
        return this.hasPermission("manageOrganizationMembership") && <OrganizationMembership organization={this.state.selectedOrganization.id}></OrganizationMembership>;
    };
    Permissions = () => {
        return this.hasPermission("permissions.read") && <OrganizationUserPermissions organization={this.state.selectedOrganization.id}></OrganizationUserPermissions>;
    };
    Roles = () => {
        return this.hasPermission("manageUserPermissions") && <OrganizationRoles organization={this.state.selectedOrganization.id}></OrganizationRoles>;
    };

    ManagedServices = () => {
        return this.hasPermission("listManagedServices") && <OrganizationManagedServices></OrganizationManagedServices>;
    };
    Communication = () => {
        return this.hasPermission("manageOrganizationCommunication") && <OrganizationCommunication organization={this.state.selectedOrganization.id}></OrganizationCommunication>;
    };
    Branding = () => {
        return this.hasPermission("manageOrganizationBranding") && <OrganizationBranding organization={this.state.selectedOrganization.id}></OrganizationBranding>;
    };

    render() {
        return (
            <div>
                <OrganizationContextSwitcher></OrganizationContextSwitcher>
                {!this.state.selectedOrganization && <div>No Organization Selected</div>}
                {this.state.selectedOrganization && (
                    <>
                        <div className="bg-white border-b border-gray-200 shadow-sm">
                            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                                <div className="flex items-center space-x-4">
                                    {this.state.selectedOrganization.logoUri && (
                                        <img className="h-16 w-auto object-contain" src={this.state.selectedOrganization.logoUri} alt={this.state.selectedOrganization.name || "Organization logo"} />
                                    )}
                                    <h1 className="text-2xl font-bold text-gray-900">{this.state.selectedOrganization.name || "Unknown Organization"}</h1>
                                </div>
                            </div>
                        </div>

                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                            <Routes>
                                <Route
                                    path="/"
                                    element={
                                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                            {Tabs.map((tab, i) => (
                                                <div
                                                    key={tab.name}
                                                    onClick={() => this.props.navigate(tab.route)}
                                                    className="group relative bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-lg hover:border-blue-300 transition-all duration-200 cursor-pointer overflow-hidden"
                                                >
                                                    {/* Gradient accent bar */}
                                                    <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 to-purple-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
                                                    
                                                    {/* Icon with background */}
                                                    <div className="flex items-start space-x-4">
                                                        <div className="flex-shrink-0">
                                                            <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-50 to-purple-50 flex items-center justify-center group-hover:from-blue-100 group-hover:to-purple-100 transition-colors duration-200">
                                                                <FontAwesomeIcon icon={tab.icon} className="text-2xl text-blue-600 group-hover:text-purple-600 transition-colors duration-200" />
                                                            </div>
                                                        </div>
                                                        
                                                        {/* Content */}
                                                        <div className="flex-1 min-w-0">
                                                            <h3 className="text-lg font-semibold text-gray-900 group-hover:text-blue-600 transition-colors duration-200 mb-1">
                                                                {tab.name}
                                                            </h3>
                                                            <p className="text-sm text-gray-600 line-clamp-2">
                                                                {tab.description}
                                                            </p>
                                                        </div>
                                                        
                                                        {/* Arrow indicator */}
                                                        <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all duration-200">
                                                            <FontAwesomeIcon icon={["fad", "arrow-right"]} className="text-blue-600" />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    }
                                ></Route>
                                <Route path="/information" element={this.Information()}></Route>
                                <Route
                                    path="/clients"
                                    element={
                                        <ClientsTable
                                            user={this.state.currentUser}
                                            organization={this.state.selectedOrganization}
                                            policies={this.state.policies}
                                            toggleCreateClientModal={this.toggleCreateClientModal}
                                        ></ClientsTable>
                                    }
                                ></Route>
                                <Route path="/clients/:id/secrets" element={<ClientSecrets user={this.state.currentUser} policies={this.state.policies}></ClientSecrets>}></Route>
                                <Route path="/clients/:id/permissions" element={<ClientPermissions user={this.state.currentUser} policies={this.state.policies}></ClientPermissions>}></Route>
                                <Route path="/clients/manageExternal" element={<ManageExternalClient user={this.state.currentUser} policies={this.state.policies}></ManageExternalClient>}></Route>
                                <Route path="/registration" element={this.Registration()}></Route>
                                <Route path="/integrations" element={this.Integrations()}></Route>
                                <Route path="/membership" element={this.Membership()}></Route>
                                <Route path="/permissions" element={this.Permissions()}></Route>
                                <Route path="/roles" element={this.Roles()}></Route>
                                <Route path="/managedServices" element={this.ManagedServices()}></Route>
                                <Route path="/communication" element={this.Communication()}></Route>
                                <Route path="/branding" element={this.Branding()}></Route>
                            </Routes>
                        </div>
                    </>
                )}
                <Modal isOpen={this.state.showCreateClientModal} onClose={this.toggleCreateClientModal} title="Add Client" icon={["fad", "desktop"]}>
                    <div className="p-6">{this.state.selectedOrganization && <CreateClient organization={this.state.selectedOrganization.id}></CreateClient>}</div>
                    <div className="flex justify-end items-center space-x-3 px-6 py-4 bg-gray-50 border-t border-gray-200">
                        <Button variant="outline-secondary" onClick={this.toggleCreateClientModal}>
                            Done
                        </Button>
                    </div>
                </Modal>
                <Modal isOpen={this.state.showIdentityProviderModal} onClose={this.toggleIdentityProviderModal} title="Add Identity Provider" icon={["fad", "id-card"]}>
                    <div className="p-6">{this.state.selectedOrganization && <CreateIdentityProvider organization={this.state.selectedOrganization.id}></CreateIdentityProvider>}</div>
                    <div className="flex justify-end items-center space-x-3 px-6 py-4 bg-gray-50 border-t border-gray-200">
                        <Button variant="outline-secondary" onClick={this.toggleIdentityProviderModal}>
                            Done
                        </Button>
                    </div>
                </Modal>
            </div>
        );
    }
}
